import type { Params } from 'react-router';

import { urls } from '~/urls';

export default function generate(
  params: Params,
  /** Entry points stay hidden when the control deck isn't configured. */
  features: { missingPieces: boolean } = { missingPieces: false }
) {
  return [
    {
      heading: 'Shop With Us',
      links: [],
    },
    {
      heading: 'Get to Know Us',
      links: [{ to: urls.general.about(params), title: 'About Us' }],
    },
    {
      heading: 'Let Us Help You',
      links: [
        { to: urls.general.contact(params), title: 'Customer Support' },
        ...(features.missingPieces
          ? [{ to: urls.general.missingPieces(params), title: 'Report Missing Pieces' }]
          : []),
        { to: urls.legal.returns(params), title: 'Returns, Refunds & Cancellations' },
        { to: urls.legal.terms(params), title: 'Terms & Conditions' },
        { to: urls.legal.privacy(params), title: 'Privacy Statement' },
        { to: urls.legal.shipping(params), title: 'Shipping & Delivery' },
      ],
    },
    {
      heading: 'Looking for something else?',
      links: [
        { to: urls.boc.boardGames(params), title: 'Buy Board Games' },
        { to: urls.boc.pokemon(params), title: 'Buy Original Pokémon' },
        { to: urls.boc.kpop(params), title: 'Buy KPop Sleeves' },
        { to: urls.boc.explodingKittens(params), title: 'Buy Exploding Kittens' },
      ],
    },
  ];
}
